import React from 'react'

import {
  Box,
  Chip,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Loader,
  makeAppStyles,
  RoundedPlainTextButton,
} from '@percept/mui'

import { Add } from '@percept/mui/icons'

import { useMediaAcademyResources } from './hooks'

import { flatMap } from 'lodash-es'

import { formatLocal } from '@percept/utils'

import { mediaAcademyResouceCategoryLabels } from './lib'

import { MediaAcademyResourceCategory } from './typings'


const useChipStyles = makeAppStyles( theme => ({
  root: {
    height: 18,
    fontSize: 11,
    marginRight: theme.spacing(1),
  },
  label: {
    padding: theme.spacing(0, 0.5),
  },
  deleteIcon: {
    width: 14,
    height: 14,
    marginRight: 2,
    marginLeft: -1,
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: 1,
    marginLeft: 1,
  },
}))


export type ResourceListingProps = {
  category?: MediaAcademyResourceCategory | null
}

export const ResourceListing = ({
  category
}: ResourceListingProps): JSX.Element => {

  const {
    isLoading,
    isError,
    data,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useMediaAcademyResources({
    category,
    order: 'DESC',
    limit: 20
  })

  const chipClasses = useChipStyles()

  if( isLoading ){
    return <Loader preset='centered' minHeight='10rem' />
  }

  const resources = data && flatMap(data.pages, p => p.items)

  if( isError || (resources && !resources.length) ){
    return (
      <Box
        pt={5}
        px={3}
        display='flex'
        justifyContent='center'
        fontSize={16}
        color='text.secondary'>
        No resources found
      </Box>
    )
  }

  return (
    <>
      <List disablePadding>
        { resources && resources.map( r => (
          <ListItem
            key={r.id}
            button
            component='a'
            target='_blank'
            rel='noopener noreferrer'
            href={r.external_url}>
            <ListItemText
              primary={r.name}
              primaryTypographyProps={{
                variant: 'subtitle2',
              }}
              secondary={
                <Box display='flex' alignItems='center'>
                  <Chip
                    classes={chipClasses}
                    size='small'
                    variant='outlined'
                    color='secondary'
                    label={mediaAcademyResouceCategoryLabels[r.category]} />
                  Published {formatLocal(new Date(r.published_date), 'dd/MM/yy')}
                </Box>
              } />
          </ListItem>
        ))}
      </List>

      { hasNextPage && (
        <Box display='flex' justifyContent='center' mt={4}>
          <RoundedPlainTextButton
            variant='contained'
            disabled={isFetchingNextPage}
            startIcon={
              isFetchingNextPage ?
                <CircularProgress size='1em' color='inherit' /> :
                <Add />
            }
            onClick={(): void => {
              fetchNextPage()
            }}>
            Load More
          </RoundedPlainTextButton>
        </Box>
      )}
    </>
  )
}
